export function changeDateFormat(obj: any, elements: string[]) {
  elements.forEach((el) => {
    const [day, month, year] = obj[el].split('.');
    if (obj[el].split('.').length !== 1) {
      obj[el] = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    }
  });
}
